import { cn } from "@/lib/utils";

type SpinnerProps = {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
};

const sizeMap = {
  sm: "size-4",
  md: "size-6",
  lg: "size-8",
  xl: "size-12",
};

export const Spinner = ({ size = "md", className }: SpinnerProps) => {
  return (
    <div
      className={cn(
        "animate-spin rounded-full border-2 border-current border-t-transparent text-palomma-primary",
        sizeMap[size],
        className
      )}
      role="status"
      aria-label="Loading"
    />
  );
};
